import { Component } from "@angular/core";

@Component({
	selector: "sdi-news-media",
	templateUrl: "./news-media.component.html",
	styleUrls: ["./news-media.component.scss"]
})
export class NewsMediaComponent {}
